import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FolderOpenTwoToneSvg from "@ant-design/icons-svg/es/asn/FolderOpenTwoTone";
import AntdIcon from "../components/AntdIcon";
var FolderOpenTwoTone = function FolderOpenTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderOpenTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FolderOpenTwoTone.displayName = 'FolderOpenTwoTone';
}
export default /*#__PURE__*/React.forwardRef(FolderOpenTwoTone);